import { render, staticRenderFns } from "./NoticeFeedbackDialog.vue?vue&type=template&id=00f85c3a&scoped=true&"
import script from "./NoticeFeedbackDialog.vue?vue&type=script&lang=js&"
export * from "./NoticeFeedbackDialog.vue?vue&type=script&lang=js&"
import style0 from "./NoticeFeedbackDialog.vue?vue&type=style&index=0&id=00f85c3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f85c3a",
  null
  
)

export default component.exports